module.exports = __webpack_public_path__ + "static/img/19.ec49e24.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/19.png
// module id = 0PIL
// module chunks = 1